import { apiClient } from './client'
import type { ApiResponse } from '../types/api'
import type { CreatePlatformSnapshotBody, PlatformSnapshotReport } from '../types/platformSnapshot'

export const platformSnapshotApi = {
  /** Whether this admin passes the snapshot guards (all three allowlists). */
  checkAccess: () => apiClient.get<ApiResponse<{ allowed: boolean }>>('/admin/platform-snapshots/access'),

  /** Queues a new report. Needs a fresh authenticator code every time. */
  create: (data: CreatePlatformSnapshotBody) =>
    apiClient.post<ApiResponse<PlatformSnapshotReport>>('/admin/platform-snapshots', data),

  /** Every report, most recent first — from any admin, not just this one. */
  list: () => apiClient.get<ApiResponse<PlatformSnapshotReport[]>>('/admin/platform-snapshots'),

  get: (id: string) => apiClient.get<ApiResponse<PlatformSnapshotReport>>(`/admin/platform-snapshots/${id}`),

  /** A short-lived presigned S3 URL for the workbook. 404 unless ready and unexpired. */
  getDownloadUrl: (id: string) =>
    apiClient.get<ApiResponse<{ url: string }>>(`/admin/platform-snapshots/${id}/download`),
}
